/* eslint-disable react/require-default-props */
import React from 'react';
import './styles.scss';
export default function MultipleSuggestionsSection({ suggestedClauses, onUpdateSelectedClause, markedForSuggestion }) {
    const handleRowClick = (event, section) => {
        if (markedForSuggestion) {
            return;
        }
        const target = event.target;
        if (target.type !== 'checkbox') {
            onUpdateSelectedClause(section);
        }
    };
    return (React.createElement("div", { className: "suggestion-section" },
        React.createElement("div", { className: "suggestion-section__title" }, "Suggestions"),
        React.createElement("div", { className: "suggestion-section__list" }, suggestedClauses.map((clause) => (React.createElement("div", { className: `suggestion-section__checkbox-item ${markedForSuggestion ? 'suggestion-section__checkbox-item--disabled' : ''}`, key: clause.section, onClick: (e) => handleRowClick(e, clause.section), role: "button", tabIndex: markedForSuggestion ? -1 : 0 },
            !markedForSuggestion ? (React.createElement("input", { checked: clause.selected, type: "checkbox", className: "suggestion-section__checkbox", onChange: (e) => {
                    e.stopPropagation();
                    onUpdateSelectedClause(clause.section);
                } })) : null,
            React.createElement("div", { className: "suggestion-section__checkbox-content" },
                React.createElement("div", { className: "suggestion-section__checkbox-label" },
                    "Code: ",
                    clause.code,
                    "; Section: ",
                    clause.section),
                React.createElement("div", { className: "suggestion-section__checkbox-description" }, clause.description))))))));
}
